import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { OpenModule } from '@campfire-nx/open';
import { MaterialModule } from '@campfire-nx/material';
import { RaptorModule } from '@campfire-nx/raptor';

import { AutoRenewalFlowComponent } from '@open-portal-app/policy/auto-renewal/auto-renewal-flow/auto-renewal-flow.component';
import { PolicyRoutingModule } from './policy-routing.module';
import { OdoReadingService } from './odo-reading/services/odo-reading.service';
import { OdoFlowManagerService } from './odo-reading/services/odo-flow-manager.service';
import { UpdatePaymentFlowManagerService } from './payment/services/update-payment-flow-manager.service';
import { PaymentRetryFlowManagerService } from './payment/services/payment-retry-flow-manager.service';

import { ComponentsModule } from '@open-portal-app/components/components.module';

import { PolicyLandingComponent } from './policy-landing/policy-landing.component';
import { PolicyDetailsLegacyComponent } from './policy-detail-legacy/policy-details/policy-details.component';
import { PolicyDetailsComponent } from './policy-details/policy-details.component';
import { ClaimDetailsComponent } from './claim-details/claim-details.component';
import { CarPolicyComponent } from './components/car-policy/car-policy.component';
import { HomePolicyComponent } from './components/home-policy/home-policy.component';
import { TravelPolicyComponent } from './components/travel-policy/travel-policy.component';
import { ClaimsListComponent } from './components/claims-list/claims-list.component';
import { ClaimTriageComponent } from './claim-triage/claim-triage.component';
import { AutoRenewalComponent } from './components/auto-renewal/auto-renewal.component';
import { OdoFlowComponent } from './odo-reading/odo-flow/odo-flow.component';
import { PaymentUpdateFlowComponent } from './payment/payment-update-flow/payment-update-flow.component';
import { PaymentRetryFlowComponent } from './payment/payment-retry-flow/payment-retry-flow.component';
import { MobilePolicyComponent } from './components/mobile-policy/mobile-policy.component';
import { PolicyHeroBannerComponent } from './components/policy-hero-banner/policy-hero-banner.component';
import { PolicyActionComponent } from './components/policy-action/policy-action.component';
import { PolicyLinkCardsComponent } from './components/policy-link-cards/policy-link-cards.component';
import { PolicyTilesComponent } from './components/policy-tiles/policy-tiles.component';
import { ExtraDetailsComponent } from './extra-details/extra-details.component';

import { AddressPipe } from '@open-portal-app/core/pipes/address.pipe';
import { DisplayDatePipe } from '@open-portal-app/core/pipes/display-date.pipe';
import { AgePipe } from '@open-portal-app/core/pipes/age.pipe';
import { GenderPipe } from '@open-portal-app/core/pipes/gender.pipe';

@NgModule({
  declarations: [
    PolicyDetailsLegacyComponent,
    PolicyDetailsComponent,
    PolicyLandingComponent,
    CarPolicyComponent,
    HomePolicyComponent,
    TravelPolicyComponent,
    ClaimsListComponent,
    AddressPipe,
    DisplayDatePipe,
    AgePipe,
    AutoRenewalComponent,
    AutoRenewalFlowComponent,
    OdoFlowComponent,
    PaymentUpdateFlowComponent,
    PaymentRetryFlowComponent,
    MobilePolicyComponent,
    GenderPipe,
    PolicyHeroBannerComponent,
    PolicyActionComponent,
    PolicyLinkCardsComponent,
    PolicyTilesComponent,
    ClaimTriageComponent,
    GenderPipe,
    ClaimDetailsComponent,
    ExtraDetailsComponent,
    GenderPipe
  ],
  imports: [
    CommonModule,
    OpenModule,
    MaterialModule,
    PolicyRoutingModule,
    ComponentsModule,
    FormsModule,
    RaptorModule
  ],
  providers: [
    OdoFlowManagerService,
    OdoReadingService,
    UpdatePaymentFlowManagerService,
    PaymentRetryFlowManagerService
  ]
})
export class PolicyModule { }
